import { Label, Typography } from 'fronton-react';
import React from 'react';
import { DurationOfUseType } from '../../constants';
import { useTranslation } from 'react-i18next';
import { labelStyles, reviewAdditionalInfoWrapper, typographyStyles } from './review.styles';
import { toDurationKey } from './util/to-duration-key';

type Props = {
  isVerified?: boolean;
  durationOfUse?: DurationOfUseType | string;
} & React.HTMLAttributes<HTMLElement>;

export const ReviewAdditionalInfo: React.FC<Props> = ({ isVerified, durationOfUse, ...htmlProps }) => {
  const { t } = useTranslation();

  const key = durationOfUse ? toDurationKey(durationOfUse) : '';
  const term = key ? t(`reviews.form.term.${key}`) : durationOfUse;

  return (
    <div className={reviewAdditionalInfoWrapper} {...htmlProps}>
      {term && (
        <Typography variant="caption" color="text-minor">
          {`${t('reviews.review.uses-duration')} ${term.toLowerCase()}`}
        </Typography>
      )}
      {isVerified && (
        <Label className={labelStyles} borderColor="brand-primary" background="background-primary">
          <Typography className={typographyStyles} size="regular" variant="mini">
            {t('reviews.review.confirmed-purchase')}
          </Typography>
        </Label>
      )}
    </div>
  );
};
